import { useList } from "@refinedev/core";
import { useEffect, useRef, useState } from "react";
import { ParticipantsInfoTable } from "./table";
import { ParticipantsInfoCard } from "./card";
import Pagination from "components/pagination";

export const ParticipantsInfo = ({currentFilterValues}: {currentFilterValues: any}) => {
  const prevFilterKeyRef = useRef<string | null>(null);
  const [participantsInfoFilters, setParticipantsInfoFilters] = useState({
    page: "1"
  })
  const {
    data,
    refetch,
    isLoading
  } = useList<any>({
    resource: `dashboard/event/${currentFilterValues.event_id}/participant-information`,
    pagination: {
      mode: "off"
    },
    meta: {
      resource: "data",
      filters: [
        { field: "from_date", operator: "eq", value: currentFilterValues.from_date },
        { field: "to_date", operator: "eq", value: currentFilterValues.to_date },
        { field: "ticket_platform", operator: "eq", value: currentFilterValues.ticket_platform },
        { field: "page", operator: "eq", value: participantsInfoFilters.page }
      ],
    },
    queryOptions: {
      enabled: false
    } as any
  });

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [participantsInfoFilters]);

  useEffect(() => {
    const key = JSON.stringify(currentFilterValues);
    if (prevFilterKeyRef.current === null) {
      prevFilterKeyRef.current = key;
      return;
    }
    if (prevFilterKeyRef.current === key) return;
    prevFilterKeyRef.current = key;
    setParticipantsInfoFilters({
      page: "1"
    })
  }, [currentFilterValues]) // reset state on filter props change

  const _handleFilterChange = (key: string, value: any) => {
    const updatedFilter = {
      [key]: value,
      ...(key !== "page" && {page: "1"})
    }
    setParticipantsInfoFilters({
      ...participantsInfoFilters,
      ...updatedFilter
    })
  }


  const tableQueryResult = data;
  
  return (
    <div className="box-container">
      <div className="sm:hidden">
        <ParticipantsInfoCard 
          data={tableQueryResult?.data}
          pageSize={tableQueryResult?.pageSize}
          currentPage={tableQueryResult?.paging.current_page}
          isLoading={isLoading}
        />
      </div>
      <div className="hidden sm:block">
        <ParticipantsInfoTable
          data={tableQueryResult?.data}
          pageSize={tableQueryResult?.pageSize}
          currentPage={tableQueryResult?.paging.current_page}
          isLoading={isLoading}
        />
      </div>
      {tableQueryResult?.paging  && tableQueryResult.paging.total_page > 1 ? (
        <div className="mt-6">
          <Pagination 
            hideTotal
            currentPage={tableQueryResult?.paging.current_page}
            totalPage={tableQueryResult?.paging.total_page}
            total={{
              totalItems: tableQueryResult?.paging.total_item || 0,
              total: tableQueryResult?.paging.total
            }}
            onChange={(page: number) => _handleFilterChange("page", page)}
          />
        </div>
      ) : <></>}
    </div>
  )
}